<template>
  <section class="bg-white">
    <div id="fb-root"></div>
    <div class="menu-header">
      <div class="header-top">
        <div class="header-left">
          <Tag type="primary"
               outline
               size="small"
               class="mr-4"
               v-if="menuCategoryTag">
               {{menuCategoryTag}}
          </Tag>
          <div class="menu-id" v-if="menuBasicInfo && menuBasicInfo.menuNo">
            メニューNo. {{menuBasicInfo.menuNo}}
          </div>
        </div>
        <div class="header-right">
          <Share />
        </div>
      </div>
      <h2 class="menu-title" v-if="menuBasicInfo && menuBasicInfo.menuNm">
        {{ menuBasicInfo && menuBasicInfo.menuNm | capitalize }}
      </h2>
      <div class="header-meta">
        <div class="meta-item inline-flex mr-4" v-if="getAreaName">
          <i class="icon icon-bor-pin pt-1 pr-2" />
          <span>
            {{getAreaName}}
          </span>
        </div>
        <button class="c-btn btn-white btn-sm" @click="gotoMap" v-if="hasCoordinates">
          地図を見る
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import { SAVE_FAVORITE, GET_STATUS_FAVORITE, DELETE_FAVORITE } from '@/store/modules/bs_myp/actions'

export default {
  name: 'MenuDetailHeader',
  components: {
  },
  props: ['value'],
  data() {
    return {
      statusFavorite: false,
      menuBasicInfo: null,
      showPopup: false
    }
  },
  created() {
    if (this.value) {
      this.menuBasicInfo = this.value
    }
  },
  mounted() {
    this.getStatusFavorite()
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        console.log('this.menuBasicInfo ', val)
        this.menuBasicInfo = val
      }
    }
  },
  methods: {
    gotoMap() {
      this.$emit('gotoMap')
    },
    copyContent() {
      return location.href
    },
    copySuccess() {
      this.$toasted.success('Copied')
    },
    copyError() {
      this.$toasted.error('Copy failed')
    },
    checkLogin() {
      const { menuNo } = this.$route.query
      const data = {
        itemType: 'favourite', 
        menuNo
      }

      if(this.statusFavorite) {
        this.$store.dispatch(DELETE_FAVORITE, this.idFavorite).then(
          () => {
            this.statusFavorite = false
            // this.getStatusFavorite()
          },
          (error) => {
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      } else {
        this.$store.dispatch(SAVE_FAVORITE, data).then(
          (result) => {
            this.idFavorite = _.get(result, 'id', '')
            this.statusFavorite = true
            // this.getStatusFavorite()
          },
          (error) => {
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      }
    },
    getStatusFavorite() {
      const { menuNo } = this.$route.query
      const params = {
        menuNo
      }
      this.$store.dispatch(GET_STATUS_FAVORITE, params).then(
        (data) => {
          if (data) {
            this.statusFavorite = _.get(data, 'data.favourite', '')
            this.idFavorite = _.get(data, 'data.id', '')
          }
        },
        (error) => {
          this.$toasted.error(error && error.message ? error.message : error)
        }
      )

    }
  },
  computed: {
    hasCoordinates() {
      return _.get(this.menuBasicInfo, 'areaInfomation.latitude', null) && _.get(this.menuBasicInfo, 'areaInfomation.longitude', null)
    },
    getAreaName() {
      // areaMidClassNm > areaDtlClassNm
      if (this.menuBasicInfo && this.menuBasicInfo.areaInfomation) {
        const areaMidClassNm = this.menuBasicInfo.areaInfomation.areaMidClassNm
        const areaDtlClassNm = this.menuBasicInfo.areaInfomation.areaDtlClassNm
        return `${areaMidClassNm ? `${areaMidClassNm}` : ''}${areaMidClassNm && areaDtlClassNm ? ' > ' : ''}${areaDtlClassNm ? `${areaDtlClassNm}` : ''}`
      }
      return ''
    },
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    },
    menuCategoryTag() {
      let categoryNm = ''
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')) {
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catLrgClassNm')
      }
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catMidClassNm')
      }
      if (_.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += _.get(this.menuBasicInfo, 'categoryInfomation.catSmlClassNm')
      }
      return categoryNm
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
